// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: var(--dark);
  color: #94a3b8;
  margin-top: auto;
}

.footer-inner {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 64px;
  padding: 64px 24px 48px;
}

.footer-logo {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--white);
}

.footer-tagline {
  margin-top: 12px;
  font-size: .9rem;
  line-height: 1.7;
}
.footer-tagline a { color: #93c5fd; }
.footer-tagline a:hover { color: var(--white); }

.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.footer-col h4 {
  font-size: .8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .08em;
  color: var(--white);
  margin-bottom: 16px;
}

.footer-col ul { list-style: none; }
.footer-col ul li { margin-bottom: 10px; }
.footer-col ul li a { color: #94a3b8; font-size: .9rem; }
.footer-col ul li a:hover { color: var(--white); text-decoration: none; }
.footer-col .text-muted { font-size: .875rem; }

.footer-bottom {
  border-top: 1px solid #1e293b;
  padding: 20px 0;
}
.footer-bottom .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: .8rem;
  color: #64748b;
}

@media (max-width: 768px) {
  .footer-inner { grid-template-columns: 1fr; gap: 32px; padding: 40px 24px 32px; }
  .footer-links { grid-template-columns: repeat(2, 1fr); }
  .footer-bottom .container { flex-direction: column; gap: 4px; text-align: center; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,oBAAoB,cAAc,EAAE;AACpC,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iBAAiB,gBAAgB,EAAE;AACnC,oBAAoB,mBAAmB,EAAE;AACzC,sBAAsB,cAAc,EAAE,gBAAgB,EAAE;AACxD,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE;AACxE,0BAA0B,kBAAkB,EAAE;;AAE9C;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB,0BAA0B,EAAE,SAAS,EAAE,uBAAuB,EAAE;EAChF,gBAAgB,qCAAqC,EAAE;EACvD,4BAA4B,sBAAsB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACpF","sourcesContent":[".footer {\n  background: var(--dark);\n  color: #94a3b8;\n  margin-top: auto;\n}\n\n.footer-inner {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 64px;\n  padding: 64px 24px 48px;\n}\n\n.footer-logo {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--white);\n}\n\n.footer-tagline {\n  margin-top: 12px;\n  font-size: .9rem;\n  line-height: 1.7;\n}\n.footer-tagline a { color: #93c5fd; }\n.footer-tagline a:hover { color: var(--white); }\n\n.footer-links {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n}\n\n.footer-col h4 {\n  font-size: .8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: .08em;\n  color: var(--white);\n  margin-bottom: 16px;\n}\n\n.footer-col ul { list-style: none; }\n.footer-col ul li { margin-bottom: 10px; }\n.footer-col ul li a { color: #94a3b8; font-size: .9rem; }\n.footer-col ul li a:hover { color: var(--white); text-decoration: none; }\n.footer-col .text-muted { font-size: .875rem; }\n\n.footer-bottom {\n  border-top: 1px solid #1e293b;\n  padding: 20px 0;\n}\n.footer-bottom .container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: .8rem;\n  color: #64748b;\n}\n\n@media (max-width: 768px) {\n  .footer-inner { grid-template-columns: 1fr; gap: 32px; padding: 40px 24px 32px; }\n  .footer-links { grid-template-columns: repeat(2, 1fr); }\n  .footer-bottom .container { flex-direction: column; gap: 4px; text-align: center; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
